
import { CommonModule } from '@angular/common';  
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { PagerComponent } from './components/pager/pager.component';
import {TableSorterComponent} from './components/table-sorter/table-sorter.component';

import { AlertService } from './services/alert.service';

@NgModule({
  declarations: [SpinnerComponent, TableSorterComponent, PagerComponent],
  imports: [CommonModule],
  exports: [SpinnerComponent, TableSorterComponent, PagerComponent]
})
export class CoreLibModule { 

  public static forRoot(environment: any): ModuleWithProviders<CoreLibModule> {

    return {
        ngModule: CoreLibModule,
        providers: [ 
            AlertService,          
            {
                provide: 'environment', // you can also use InjectionToken
                useValue: environment
            }
        ]  
    };
}

}
